import { crossings } from '@/api/crossings'

const getDefaultState = () => {
  return {
    list: []
  }
}

const state = getDefaultState()

const mutations = {
  SET_CROSSINGS: (state, data) => {
    state.list = data
  }
}

const actions = {
  getCrossings ({ commit }, params) {
    return new Promise((resolve, reject) => {
      crossings(params).then(response => {
        const data = response.data
        commit('SET_CROSSINGS', data)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
